<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="500px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <span slot="title">
      <img src="@/assets/images/system/company.png" />关联子公司
    </span>
    <div class="content">
      <el-form ref="form" class="form" :model="form" :rules="rules">
        <el-form-item prop="companyIds" label="选择公司">
          <el-select v-model="form.companyIds" style="width: 100%" multiple collapse-tags filterable clearable placeholder="请输入选择公司">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <p class="tips">
          <i class="el-icon-warning" /> 关联后，所选公司将成为本公司旗下子公司
        </p>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel" @click="cancel">取 消</div>
      <div class="ok" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
import { getSingleCompanyList, addSubCompany } from '@/api/system'
 export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
        type: Object,
        default: () => {}
    }
  },
  data() {
    return {
      form: {
        companyIds: ''
      },
      rules: {
        companyIds: [{ required: true, message: '请输入选择公司', trigger: 'blur' }]
      },
      options: []
    }
  },
  watch: {
    dialogVisible(val) {
        if (val) {
            this.getList()
        }
    }
  },
  methods: {
    async getList() {
        try {
            const res = await getSingleCompanyList({companyId: this.rowData.id})
            if (res.success) {
                this.options = res.data.map(item => {
                    return {
                        value: item.id,
                        label: `${item.code}-${item.wbName}`
                    }
                })
            } else {
                this.$message.error(res.errorMessage)
            }
        } catch (error) {
            console.log(error)
        }
    },
    cancel() {
      this.$refs['form']?.resetFields()
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
            try {
                const res = await addSubCompany({
                    parentCompanyId: this.rowData.id,
                    companyIds: this.form.companyIds
                })
                if (res.success) {
                    this.$message.success('关联成功')
                    this.$emit('ok')
                } else {
                    this.$message.error(res.errorMessage)
                }
            } catch (error) {
                console.log(error)
            }
        //   this.$emit('ok', this.form)
        //   this.$refs[formName]?.resetFields()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
.tips {
    color: #FF7444;
}
.footers {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
